import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../assets/landing.css';
import heroImage from '../assets/heroimage.png'
import heroImage2 from '../assets/heroimage2.png'
import AdvancedSearchModal from '../components/modal/AdvancedSearch';
import MediaLanding from '../assets/mediaLanding.jpg';
import logo from '../assets/logo-white.png'

const Landing2 = ({user}) => {
  const [searchKeyword, setSearchKeyword] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [models, setModels] = useState([]);
  const [reports, setReports] = useState([]);
  const [media, setMedia] = useState([]);
  const navigate = useNavigate();

  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
        try {
            // setLoading(true); // Start loading
            
            // Fetch 3D Models
            const modelsResponse = await fetch('https://geoid-rest.vercel.app/models');
            const modelsData = await modelsResponse.json();
            const publicModels = modelsData.filter(model => model.access === 'public');
            setModels(publicModels);

            // Fetch Reports
            const mediaResponse = await fetch('https://geoid-rest.vercel.app/media');
            const mediaData = await mediaResponse.json();
            const publicmedia = mediaData.filter(report => report.access === 'public');
            setMedia(publicmedia);

            // Fetch Reports
            const reportsResponse = await fetch('https://geoid-rest.vercel.app/paper_report');
            const reportsData = await reportsResponse.json();
            const publicReports = reportsData.filter(report => report.access === 'public');
            setReports(publicReports);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            // setLoading(false);
        }
    };

    fetchData();
  }, []);

  const handleSimpleSearch = () => {
    navigate('/home', { state: { keyword: searchKeyword } });
  };
  
  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
      setIsModalOpen(false);
  };

  const handleViewModel = (model, data) => {
    navigate('/model/view-model', { state: { model, data } });
  };

  const handleUploadClick = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };


  function Modal({ isVisible, onClose }) {
    if (!isVisible) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Upload</h2>
                <button onClick={() => navigate('/upload')} className="modal-button">Upload Model</button>
                <button onClick={() => navigate('/upload-reports')} className="modal-button">Upload Reports</button>
                <button onClick={() => navigate('/upload-multimedia')} className="modal-button">Upload Multimedia</button>
                <button onClick={onClose} className="modal-close-button-upload">Close</button>
            </div>
        </div>
    );
  }

  return (
    <div className="landing-container" style={{ overflow: 'hidden' }}>
      <main>
        <section className="hero">
          <h1>Discover Immersive Diary of The Earth</h1>
          <button className="explore-btn" onClick={() => navigate('/home')}>Explore</button>
          <img className='hero-image' src={heroImage}/>
          <img className='hero-image2' src={heroImage2}/>
          <div className="triangle triangle1"></div>
          <div className="triangle triangle2"></div>
          <div className="triangle triangle3"></div>
          <div className="triangle triangle4"></div>
          <div className="triangle triangle5"></div>
          <div className="triangle triangle6"></div>
          <div className="triangle triangle7"></div>
          <div className="triangle triangle8"></div>
          <div className="triangle triangle9"></div>
        </section>

        <section className="geoid">
          <img src={logo} style={{width: '40%', height: '10%'}}/>
          <p>Geospatial Integrated Database</p>
          <div className="search-bar">
            <input 
              type="text" 
              placeholder="Search..." 
              value={searchKeyword}
              onChange={(e) => setSearchKeyword(e.target.value)}
            />
            <button onClick={handleSimpleSearch}>Search</button>
          </div>
          <a onClick={openModal} style={{cursor: 'pointer'}} className="advanced-search">Advance search</a>
        </section>

        <section className="models">
          <h2>Our resources</h2>
          <div style={{display: 'flex', justifyContent: 'center'}}>
            <div style={{width: '60%'}}>
              <p style={{fontSize: '15px'}}>Explore registered geo-heritage and archaeological sites through immersive <strong>3D models</strong>, 
                in-depth research <strong>reports and journals</strong>, and captivating <strong>multimedia content</strong>, 
                including videos and images.</p>
            </div>
          </div>
          <img className='hero-image3' src={heroImage2}/>
          <div className='group-card'>
            <div className="model-cards">
              {models.slice(-1).map((model) => (
                <div key={model.id} className="model-card">
                  <div className="card-inner">
                    <div className="card-front" 
                      style={{ backgroundImage: `url(${model.imgSrc})` }}>
                    </div>
                    <div className="card-back">
                      <h3>{model.name}</h3>
                      <p>{model.data.type}</p>
                      <h3>3D MODEL</h3>
                      <p>{model.location}</p>
                      <button onClick={() => handleViewModel(model.model, model.data)} className="view-button">View</button>
                    </div>
                  </div>
                </div>
              ))}
              <button className="more-btn" onClick={() => navigate('/model')}>Explore More</button>
            </div>

            <div className="model-cards">
              {reports.slice(-1).map((model) => (
                <div key={model.id} className="model-card">
                  <div className="card-inner">
                    <div className="card-front" 
                      style={{ backgroundImage: `url(${MediaLanding})` }}>
                    </div>
                    <div className="card-back">
                      <h3>{model.title}</h3>
                      <p>{model.publicationType}</p>
                      <h3>REPORT/JOURNAL</h3>
                      <p>{model.district} , {model.state}</p>
                      <button onClick={() => window.open(model.file, '_blank')} className="view-button">View</button>
                    </div>
                  </div>
                </div>
              ))}
              <button className="more-btn" onClick={() => navigate('/reports')}>Explore More</button>
            </div>

            <div className="model-cards">
              {media.slice(-1).map((model) => (
                <div key={model.id} className="model-card">
                  <div className="card-inner">
                    <div className="card-front" 
                      style={{ backgroundImage: `url(${model.imgSrc})` }}>
                    </div>
                    <div className="card-back">
                      <h3>{model.name}</h3>
                      <h3>MULTIMEDIA</h3>
                      <p>{model.location}</p>
                      <button onClick={() => navigate('/multimedia')} className="view-button">View</button>
                    </div>
                  </div>
                </div>
              ))}
              <button className="more-btn" onClick={() => navigate('/model')}>Explore More</button>
            </div>
          </div>
        </section>

        <section className="upload">
          <h2>Want to upload your own materials?</h2>
          {!user &&(
            <>
              <p>Register now!</p>
              <button onClick={() => navigate('/register')} className="register-btn" style={{marginRight: "10px"}}>Register</button>
              <button onClick={() => navigate('/login')} className="register-btn">Login</button>
            </>
          )}

          {user &&(
            <>
              <p>Upload now!</p>
              <button onClick={handleUploadClick} className="register-btn">Upload</button>
            </>
          )}
        </section>
      </main>

      <AdvancedSearchModal isOpen={isModalOpen} onClose={closeModal} />
      <Modal isVisible={isModalVisible} onClose={handleCloseModal} />
    </div>
  );
};

export default Landing2;